import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoadingModal } from '@adc/parallax-component-library';
import { APP_RETURN_TIMEOUT } from 'Constants';
import jwtDecode from 'jwt-decode';
import { MainContainer } from 'Components/utility';
import { AUTH_SESSION } from 'Reducers/auth/types';
import { notifyApp } from 'Utilities/appCommunicator';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { persistAuthSession } from 'Utilities/session';
import { store } from 'Utilities/store';
import { getPatient } from 'Services/patient';
const mapStateToProps = ({ nav: { query: { token, osType, osVersion, app, appVersion }, }, }) => {
    return {
        token,
        osType,
        osVersion,
        app,
        appVersion,
    };
};
const connector = connect(mapStateToProps);
const VerifyConsents = ({ token, osType, osVersion, app, appVersion }) => {
    const [loading, setLoading] = useState(false);
    const handleError = useCallback((error) => {
        notifyApp('adc-webview:navigation', error);
        // Give the app time to redirect the user back
        setTimeout(() => {
            setLoading(false);
        }, APP_RETURN_TIMEOUT);
    }, []);
    const verifyConsents = useCallback((token) => {
        setLoading(true);
        const decodedToken = jwtDecode(token);
        getPatient(decodedToken.id, osType, osVersion, app, appVersion)
            .then((patient) => {
            // Store the user session
            const authSession = {
                access_token: token,
                account_id: decodedToken.id,
                expires: decodedToken.exp,
                include: {
                    patient,
                },
            };
            persistAuthSession({
                access_token: authSession.access_token,
                account_id: authSession.account_id,
                expires: authSession.expires,
            });
            store.dispatch({ type: AUTH_SESSION, authSession });
            if (!patient.consents?.hipaa?.at) {
                mediator.publish('router:navigate', '/hipaa');
                return;
            }
            if (!patient.consents?.realWorldEvidence?.at) {
                mediator.publish('router:navigate', '/rwe');
                return;
            }
            handleError();
        })
            .catch((error) => {
            log.error('Failed to load the consents', error);
            handleError(error);
        });
    }, [app, appVersion, handleError, osType, osVersion]);
    useEffect(() => {
        if (token) {
            verifyConsents(token);
        }
    }, [token, verifyConsents]);
    return React.createElement(MainContainer, null, loading && React.createElement(LoadingModal, { "aria-label": "Loading" }));
};
export default connector(VerifyConsents);
